
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/signal-strength",
      function () {
        return require("private-next-pages/tools/signal-strength/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/signal-strength"])
      });
    }
  